import {AnyAction, ListenerEffect} from '@reduxjs/toolkit';
import {AppDispatch, ExtraArgs} from '../../createStore';
import {RootState} from '../../rootReducer';
import {loadMeetings} from '../../data/meetings/actions';
import {getWorkspaceReservationDateRange} from '../../data/workspaceReservation';
import {getStartOfDay} from '@lib/utils';
import endOfDay from 'date-fns/endOfDay';

export const loadMeetingsEffect: ListenerEffect<AnyAction, RootState, AppDispatch, ExtraArgs> = (
  _action,
  {dispatch},
) => {
  dispatch(loadMeetings(getWorkspaceReservationDateRange(_action.meta.arg)));
};

export const loadMeetingsAfterWorkdayUpdateEffect: ListenerEffect<AnyAction, RootState, AppDispatch, ExtraArgs> = (
  _action,
  {dispatch},
) => {
  const workday = _action.meta.arg;
  const from = getStartOfDay(workday.startDate);
  const to = endOfDay(from);
  dispatch(loadMeetings({from: from.toISOString(), to: to.toISOString()}));
};
